import type { Theme } from '@mui/material';

export const styles = {
  listItem: (selected: boolean) => (theme: Theme) => ({
    cursor: 'pointer',
    backgroundColor: selected ? theme.colors.neutral[200] : 'transparent',

    '&:hover': {
      backgroundColor: theme.colors.neutral[100],
    },
  }),

  subline: (theme: Theme) => ({
    color: theme.colors.neutral[400],
  }),
};
